<template>
  <div class="box1">
    <div class="content">
      <div class="tip">
        <b>课程焕新升级 V4.0</b>
        <i>对标抖音账号新玩法！</i>
      </div>
      <h1 class="title">IP短视频带货线上训练营</h1>
      <p class="desc">
        精准解锁 <a>推荐、<em></em></a>
        <a>搜索、<em></em></a>
        <a>付费<em></em></a> 三大流量密码<br />
      </p>
      <p class="desc">实现IP视频带货，成就你的超级副业！</p>
      <div class="btn" @click="childMethod">申请免费试听</div>
    </div>
    <div class="content2">
      <div class="item" v-for="(item, index) in list" :key="index">
        <template v-if="!item.p">
          <p class="number">{{ item.p1 }}<i>{{ item.i }}</i></p>
          <p class='text'>{{ item.p2 }}</p>
        </template>
         <template v-else>
          <p class="title">{{ item.p }}</p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          p1: "7-10",
          i:'年',
          p2: "专业运营讲师团",
        },
        {
          p1: "180",
          i:'天',
          p2: "高标准/精细化监督陪跑",
        },
        {
          p1: "90",
          i:'+',
          p2: "核心关键知识点",
        },
        {
          p1: "3000",
          i:'+',
          p2: "优秀毕业学员",
        },
        {
         p:'先试学再报名'
        },
      ],
    };
  },
  methods: {
    childMethod() {
      this.$parent.itcastClick();
    }
  },
};
</script>

<style lang="scss" scoped>
.box1 {
  background: url("../../../assets/topic-page/newMedia2/box1/bgc.jpg")
    no-repeat;
  height: 540px;
  background-size: 2048px auto;
  background-position: center;
  max-width: 2048px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  min-width: 1400px;
  .btn{
      width: 207px;
      height: 56px;
      font-size: 20px;
      color: #fff;
      text-align: center;
      line-height: 56px;
      border-radius: 28px;
      font-weight: bold;
      box-sizing: border-box;
      box-shadow: 0 8px 7px #e2b8db;
      background: url("../../../assets/topic-page/newMedia2/btnbg1.png") no-repeat;
      cursor: pointer;
      margin: 10px 0 0;
      padding-right: 20px;
      &:hover{
        box-shadow: none;
      }
    }
  .content {
    width: 1200px;
    
    box-sizing: border-box;
    margin: 0 auto;
    .tip {
      display: flex;
      align-items: center;
      margin-top: 85px;
      b {
        display: block;
        text-align: center;
        font-family: PingFang-SC-Bold;
        font-size: 25px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 51px;
        letter-spacing: 0px;
        color: #ffffff;
        width: 250px;
        height: 51px;
        background-color: #fd5a57;
        border-radius: 25px 25px 25px 0px;
        margin-right: 30px;
      }
      i {
        font-style: normal;
        font-family: PingFang-SC-Bold;
        font-size: 25px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #1a0a0e;
      }
    }
    .title {
      font-family: PingFang-SC-Heavy;
      font-size: 50px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 72px;
      letter-spacing: 0px;
      color: #1a0a0e;
      margin: 24px 0 38px;
    }
    .desc {
      font-family: PingFang-SC-Medium;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #1a0a0e;
       margin-bottom: 24px;
      a {
        font-weight: bold;
        position: relative;
        em {
          display: inline-block;
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 40px;
          height: 4px;
          background-color: #fd5a57;
        }
      }
    }
    
  }
  .content2 {
    width: 100%;
    height: 90px;
    background: rgba(255, 255, 255, 0.3);
   
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    margin-right: -20px;
   
    .item {
     width: 224px;
	height: 70px;
	background-color: #ffffff;
	box-shadow: inset 0px 1px 0px 0px 
		#ffffff;
	border-radius: 10px;

      text-align: center;
      margin-right: 20px;
      .number{
        font-family: DINCondensed-Bold;
        font-size: 36px;
        color: #4d1f28;
        position: relative;
        text-align: center;
        display: inline-block;
        margin: 0 auto;
        padding: 8px 0 3px;
        i{
          position:absolute;
          right: -18px;
          top: 11px;
          font-style: normal;
          font-family: PingFang-SC-Heavy;
          font-size: 16px;
          color: #4d1f28;
        }
       
      }
      .text{
        font-family: PingFang-SC-Regular;
        font-size: 16px;
        color: #242424;
        text-align: center;
      }
      .title{
        font-family: PingFang-SC-Bold;
        font-size: 24px;
        text-align: center;
        color: #4d1f28;
        line-height: 70px;
      }
    }
    .item:last-child {
      margin-right: 0;
    }
     .item:nth-child(3), .item:nth-child(4){
       i{
         font-size: 22px;
  right: -18px;
  top: 5px;
        }
    }
  }
}
</style>
